module.exports = __webpack_public_path__ + "img/earth_normal_2048.d309331c.jpg";